import { inject, Injectable } from '@angular/core';
import { HttpContext } from '@angular/common/http';
import { ApiService } from 'src/app/core/api/api.service';
import { COHORTS_ENDPOINTS } from 'src/app/core/api/endpoints/cohorts.endpoints';
import { BUTTON_LOADING_ID } from 'src/app/shared/global/http-context-tokens';

@Injectable({
  providedIn: 'root',
})
export class CohortsService {
  private api = inject(ApiService);

  getCohorts(params?: any) {
    return this.api.get(COHORTS_ENDPOINTS.V2.COHORTS, {
      params: params || {},
    });
  }

  getCohortById(id: number) {
    return this.api.get(COHORTS_ENDPOINTS.V2.COHORT_BY_ID(id));
  }

  createCohort(data: any, buttonId: string) {
    return this.api.post(COHORTS_ENDPOINTS.V2.COHORTS, data, {
      context: new HttpContext().set(BUTTON_LOADING_ID, buttonId)
    });
  }

  updateCohort(id: number, data: any, buttonId: string) {
    return this.api.patch(COHORTS_ENDPOINTS.V2.COHORT_BY_ID(id), data, {
      context: new HttpContext().set(BUTTON_LOADING_ID, buttonId)
    });
  }

  deleteCohort(id: number) {
    return this.api.delete(COHORTS_ENDPOINTS.V2.COHORT_BY_ID(id));
  }

  getCohortExperts(id: number) {
    return this.api.get(COHORTS_ENDPOINTS.V2.COHORT_EXPERTS(id));
  }

  deleteCohortExpert(cohortId: number, expertId: number) {
    return this.api.delete(COHORTS_ENDPOINTS.V2.COHORT_EXPERT_BY_ID(cohortId, expertId));
  }

  getCohortLog(id: number) {
    return this.api.get(COHORTS_ENDPOINTS.V2.COHORT_LOGS(id));
  }

}
